import { DIALOG_TYPE, PRODUCT_TYPE } from '../define/global';
import { closeDialog } from '../store/modules/dialog';
import { showPopupAD, showMobileBottomAD } from '../store/modules/popup';
import { isDevicePC } from '../utils/util';

export const openDocumentDialogClose = (store) => (next) => (action) => {
  if (
    action.type === closeDialog.type &&
    store.getState().dialog.dialogType === DIALOG_TYPE.DIALOG_OPEN_DOCUMENT
  ) {
    if (store.getState().appData.viewAD) {
      if (isDevicePC(store.getState().appData.deviceType)) {
        store.dispatch(showPopupAD());
      } else {
        store.dispatch(showMobileBottomAD());
      }
    }
  }
  return next(action);
};
